import Success from './Success-view';

export default Success;
